import { PRODUCTION_CDN, STAGING_CDN, BOUQS_ICONS } from "./url-icons.constants";
/**
 * returns a url with the file pointing to bouqs-ui icons directory
 */

export var getBouqsIconUrl = function getBouqsIconUrl(file, isProduction) {
  if (isProduction === void 0) {
    isProduction = false;
  }

  var url = isProduction ? PRODUCTION_CDN : STAGING_CDN;
  return url + "/" + file;
};
/**
 *  Get env icon
 */

export var getBouqsIconProps = (key, opts) => {
  var _BOUQS_ICONS$key;

  var {
    isProduction
  } = opts;
  var icon = (_BOUQS_ICONS$key = BOUQS_ICONS[key]) != null ? _BOUQS_ICONS$key : BOUQS_ICONS["x"];
  var {
    alt
  } = icon;
  var url = getBouqsIconUrl(icon.file, isProduction);
  return {
    url,
    alt
  };
};
//# sourceMappingURL=url-icons.utils.js.map